import React from 'react';
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";

const DivisionPurposeMQTTSearchBox = ({
                                        searchParam,
                                        setSearchParam = require,
                                        updateList,
                                        propIsReadOnly = false,
                                        propTableList,
                                        propInfo,
                                        propMqttId,
                                        propPrpos,
                                        propSe,
                                        propSeNm
                                      }) => {

  const onChangeInputBoxId = (e) => {
    setSearchParam((prev) => {
      return {...prev, searchMqttId: e.target.value};
    })
  }

  const onChangeInputBoxProps = (e) => {
    setSearchParam((prev) => {
      return {...prev, searchPrpos: e.target.value};
    })
  }

  const onSearch = async (e) => {
    e.preventDefault();
    await updateList();
  }

  return (
      <>
        <Form
            id={"searchForm"}
            className={"search-form"}
            onSubmit={(e) => onSearch(e)}
        >
          <Row className={"justify-content-md-center"}>
            <Col md={12}>
              <Row className={"text-center"}>
                <Col md={4} className={""}>
                  <Form.Group as={Row} controlId="formBasicSelectMenu">
                    <Form.Label column sm={4} className={"label text-end"}>
                      구분
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                          type="text"
                          placeholder=""
                          className={"input-search"}
                          onChange={onChangeInputBoxId}
                          disabled={true}
                          // defaultValue={propSeNm}
                          value={propSeNm}
                      />
                    </Col>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group as={Row} controlId="formBasicSelectMenu">
                    <Form.Label column sm={4} className={"label text-end"}>
                      MQTT ID
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                          type="text"
                          placeholder=""
                          className={"input-search"}
                          onChange={onChangeInputBoxId}
                          disabled={true}
                          // defaultValue={propMqttId}
                          value={propMqttId}
                      />
                    </Col>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group as={Row} controlId="formBasicSelectMenu">
                    <Form.Label column sm={4} className={"label text-end"}>
                      용도
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                          type="text"
                          placeholder=""
                          className={"input-search"}
                          onChange={onChangeInputBoxProps}
                          disabled={true}
                          // defaultValue={propPrpos}
                          value={propPrpos}
                      />
                    </Col>
                  </Form.Group>
                </Col>

              </Row>
            </Col>
          </Row>
        </Form>
      </>
  );
};

export default DivisionPurposeMQTTSearchBox;
